import { render } from "./Question.vue?vue&type=template&id=05609aa2&scoped=true&ts=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import _style_0 from "./Question.vue?vue&type=style&index=0&id=05609aa2&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-05609aa2"]])

export default __exports__